import React from 'react';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useTestimonialPageQuery } from '../../graphql/generated/graphql';
import TestimonialPageEditContainer from '../../components/testimonial-pages/TestimonialPageEditContainer';

const TestimonialPageEditPage = () => {
  const { testimonialId } = useParams();

  const { data } = useTestimonialPageQuery({
    variables: { id: Number(testimonialId) },
    fetchPolicy: 'network-only',
  })

  return (
    <Box>
      {data?.TestimonialPage.data && <TestimonialPageEditContainer testimonialPage={data?.TestimonialPage.data} />}
    </Box>
  )
}

export default TestimonialPageEditPage;
